module.exports = __webpack_public_path__ + "static/media/follower.8d516adf.svg";